import { makeDynamicDataLoader } from './factory';

var _makeDynamicDataLoade = makeDynamicDataLoader('config', function (set) {
  if (__SERVER__) {
    set(require('config').clientConfig);
  }
}),
    getConfig = _makeDynamicDataLoade.get,
    loadConfig = _makeDynamicDataLoade.load;

export { getConfig, loadConfig };